<template>
  <el-dialog :title="title" :visible="dialogFormVisible" width="40%" :before-close="handleClose" :closeOnClickModal="false">
        <el-form label-width="120px" ref="model" :model="model" :rules="rules">
            <el-form-item label="应用版本号" prop="AppVersion" >
                <el-input size="small" v-model="model.AppVersion" auto-complete="off" placeholder="请输入应用版本号" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="版本跳转路径" prop="AppUrl">
                <el-input size="small" v-model="model.AppUrl" auto-complete="off" placeholder="请输入版本跳转路径" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="版本安装包" prop="AppDownLoadUrl" v-if="AppType !='web'">
                <el-upload
                    class="upload-demo"
                    action=""
                    :http-request="handleHttpRequestDownload"
                    accept=".apk,.exe"
                    list-type="picture">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">文件类型只能是.apk或者.exe类型的</div>
                </el-upload>
                <p v-if="this.model.AppDownLoadUrl">应用安装包路径：{{this.model.AppDownLoadUrl}}</p>
            </el-form-item>
            <el-form-item label="版本更新日志" prop="AppUpdateLog">
                <el-input size="small" v-model="model.AppUpdateLog" auto-complete="off" placeholder="请输入版本更新日志" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="版本说明" prop="ReleaseNote">
                <el-input size="small" v-model="model.ReleaseNote" auto-complete="off" placeholder="请输入版本说明" maxlength="100"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='handleClose'>取消</el-button>
        <el-button size="small" type="primary"  class="title" @click="handleSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {UpdateAppLog} from '../../../api/app'
import {Upload} from '../../../api/common'
export default {
    data() {
        return {
            title: '编辑应用版本',
            name: 'add',
            limitDownload: 1,
            baseURL: window.Global.baseURL,
            model: {
                OID: null,
                AppVersion: null,
                AppUrl: '',
                AppDownLoadUrl: '',
                AppUpdateLog: '',
                ReleaseNote: '',
            },
            rules: {
                AppVersion: [{ required: true, message: '请输入配置项名称', trigger: 'blur' }],
                AppUrl: [{ required: true, message: '请输入配置项英文key', trigger: 'blur' }],
            },
        }
    },
    props: {
        dialogFormVisible: {
            required: true,
            type: Boolean
        },
        data: {
            required: true,
            type: Object
        },
        AppType: {
            required: true
        }
    },  
    mounted() {
        this.model = this.data;
        console.log(this.model)
    },
    methods: {
        handleSave() {
            this.$refs.model.validate((valid) => {
                if (valid) {
                        this.UpdateAppLog()
                } else {
                    this.$message({
                        message: '请填写完整信息',
                        type: 'warning'
                    });
                }
            });
        },
        handleClose() {
            this.$emit('closeEditDialog')
        },
        UpdateAppLog() {
            UpdateAppLog(this.model).then(data=>{
                if(!data.iserror) {
                    this.$message({
                        message: '更新成功',
                        type: 'success'
                    });
                    this.handleClose();
                }
            })
        },
        done(input){
            var regex = /^[0-9A-Za-z]+$/;
            if (input.match(regex)) {
                return true;
            } else {
                return false;
            }
        },
        handleHttpRequestDownload(a) {
            var formdata = new FormData();
            formdata.append('file', a.file)
            Upload(formdata).then(data => {
                if (!data.iserror) {
                    this.$message({
                        message: '文件上传成功',
                        type: 'success'
                    });
                    this.model.AppDownLoadUrl = this.baseURL + data.data.filePath;
                }
            })
        },
    }
}
</script>

<style>

</style>